<template>
  <div class="language-switcher" ref="switcher" style="display: flex; flex-direction: row;">
    <div>
      <svg width="19.32" height="19.32" fill="black" class="world-svg">
        <path d="M7.82 1.16a8.8 8.8 0 00-5.38 3.65h3.81c.06 0 .07 0 .08-.07l.15-.58a10.25 10.25 0 011.07-2.59l.27-.41zm9.06 3.66a8.81 8.81 0 00-5.38-3.66l.08.12c.2.36.42.71.6 1.08A12.48 12.48 0 0113 4.73c0 .08 0 .1.12.1h3.78zM7.79 18.14a11 11 0 01-1.48-3.64H2.43a8.78 8.78 0 005.36 3.64zm3.72 0a8.51 8.51 0 003-1.31 8.61 8.61 0 002.32-2.34h-3.8c-.06 0-.07 0-.09.07-.05.23-.11.46-.17.68a10.23 10.23 0 01-1 2.51c-.08.13-.17.25-.26.4zM12 4.82a11.14 11.14 0 00-.78-2.21 4 4 0 00-.93-1.32.82.82 0 00-1.18-.06A3 3 0 008.4 2a9.55 9.55 0 00-1 2.39l-.11.41zm-4.69 9.67A10.42 10.42 0 008.24 17 3.83 3.83 0 009 18a.85.85 0 001.28 0 3.08 3.08 0 00.65-.79 9.21 9.21 0 00.88-2.07c.07-.24.13-.48.2-.73zM13.2 5.8a22.46 22.46 0 01.31 3.37h4.83c0-.31-.06-.61-.11-.91a9 9 0 00-.75-2.38.13.13 0 00-.14-.09H13.2zM1 9.17h4.8a22.48 22.48 0 01.32-3.37H2a.13.13 0 00-.14.1 8.8 8.8 0 00-.78 2.57c0 .23-.05.47-.07.71zm12.2 4.36H17.46c.12-.27.24-.53.34-.81a8.54 8.54 0 00.47-1.87l.06-.64h-4.82a22.47 22.47 0 01-.31 3.38zM1 10.15c0 .29.05.58.1.86a8.92 8.92 0 00.76 2.43c0 .07.07.09.14.09h4.12a22.73 22.73 0 01-.32-3.38zM7.1 5.8a21.14 21.14 0 00-.33 3.37h5.77a20.46 20.46 0 00-.33-3.37zm-.33 4.35v.11c0 .45 0 .91.08 1.36.07.6.16 1.2.23 1.79 0 .09 0 .12.13.12h5a19.88 19.88 0 00.33-3.38zm12.55-.49A9.66 9.66 0 119.65 0a9.67 9.67 0 019.67 9.66z" />
      </svg>
    </div>
    <div ref="languageOptions" id="myDropdown">
      <select v-model="$i18n.locale" class="switcher">
        <option
          v-for="(locale, index) in $i18n.availableLocales"
          :key="`locale-${locale}`"
          :value="locale"
        >
          {{ languages[index] }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    var str = localStorage.getItem('overlap_lang');
    if (str === null) { return null; }
    this.$i18n.locale = JSON.parse(str);
  },
  data () {
    return {
      languages: ['Deutsch', 'English','Español','Français','Português'],
    };
  },
  watch: {
    '$i18n.locale' (to) {
      localStorage.setItem('overlap_lang', JSON.stringify(to));
    }
  },
};
</script>

<style scoped>
.switcher {
  width: 100px;
  border: 1px solid lightgray;
  box-shadow: 2px 2px darkgray;
  text-align: center;
}
.language-switcher {
  width: 120px;
}
.world-svg {
  margin-right: 7px;
}
</style>